import styled from 'styled-components'
import { Box, Typography } from 'src/components'
export const ContentAcceptTerms = styled(Box)`
    width: 100%;
    height: 100%;
    display: flex;
    border-radius: 11px;
    align-items: center;
    justify-content: start;
    color: ${({ theme }) => theme.colors.white};
    .MuiSvgIcon-root .MuiSvgIcon-fontSizeMedium .css-i4bv87-MuiSvgIcon-root {
        color: ${({ theme }) => theme.colors.white};
        border-radius: 80px;
        @media screen and (min-width: ${({ theme }) =>
                theme.breakpoints.tablet}) {
            color: ${({ theme }) => theme.colors.white};
            border-radius: 80px;
        }

        @media screen and (min-width: ${({ theme }) =>
                theme.breakpoints.desktop}) {
            color: ${({ theme }) => theme.colors.white};
            border-radius: 80px;
        }
    }
    .MuiSvgIcon-root {
        color: ${({ theme }) => theme.colors.white};
        border-radius: 80px;
        @media screen and (min-width: ${({ theme }) =>
                theme.breakpoints.tablet}) {
            color: ${({ theme }) => theme.colors.white};
            border-radius: 80px;
            width: 100%;
        }

        @media screen and (min-width: ${({ theme }) =>
                theme.breakpoints.desktop}) {
            color: ${({ theme }) => theme.colors.white};
            border-radius: 80px;
            width: 100%;
        }
    }
    .MuiSvgIcon-fontSizeMedium {
        color: ${({ theme }) => theme.colors.white};
        border-radius: 80px;
        @media screen and (min-width: ${({ theme }) =>
                theme.breakpoints.tablet}) {
            color: ${({ theme }) => theme.colors.white};
            border-radius: 80px;
        }

        @media screen and (min-width: ${({ theme }) =>
                theme.breakpoints.desktop}) {
            color: ${({ theme }) => theme.colors.white};
            border-radius: 80px;
        }
    }
    .css-i4bv87-MuiSvgIcon-root {
        color: ${({ theme }) => theme.colors.white};
        border-radius: 80px;
        @media screen and (min-width: ${({ theme }) =>
                theme.breakpoints.tablet}) {
            color: ${({ theme }) => theme.colors.white};
            border-radius: 80px;
        }

        @media screen and (min-width: ${({ theme }) =>
                theme.breakpoints.desktop}) {
            color: ${({ theme }) => theme.colors.white};
            border-radius: 80px;
        }
    }
`

export const ContainerAcceptTerms = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-self: center;

    width: 100%;
    .css-i4bv87-MuiSvgIcon-root {
        color: ${({ theme }) => theme.colors.white};
        border-radius: 30px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        height: 18px;
        margin-left: -10px;
    }

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        height: 28px;
        margin-left: -10px;
    }
`

export const ContentErrorDataMessage = styled(Box)`
    align-items: center;
    justify-content: start;
    display: flex;

    height: 10px;
    width: 378px;
`

export const ErrorImgBox = styled(Box)`
    width: 14.17px;
    height: 14.17px;
    margin-right: 6px;
`
export const ErrorText = styled(Typography)`
    font-family: inherit;
    color: ${({ theme }) => theme.colors.danger};
    margin-right: 20px;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-around;
    padding-right: 20px;
    margin-top: 4px;
    line-height: 12px;
`
